/* istanbul ignore file */
import Vue from "vue";
import FacetWrapper from "../FacetWrapper.vue";
import FacetItem from "../FacetItem.vue";

const vueElQuery = "[data-vue-app='show_more_facets']";
const vueView = "[data-vue-view]";

document.ready.then(() => {
  const isVueView = document.querySelectorAll(vueView).length > 0;
  if (!isVueView) {
    for (let vueEl of document.querySelectorAll(vueElQuery)) {
      new Vue({
        el: vueEl,
        components: {
          "store-facet-wrapper": FacetWrapper,
          "store-facet-item": FacetItem,
        },
      });
    }
  }
});
